<template>
  <div class="text-center">
    <v-dialog persistent v-model="dialog" width="800">
      <v-card>
        <v-card-title
          class="d-flex justify-space-between headline purple accent-4 py-1"
        >
          <div class="subtitle-1 white--text">
            Update Pre-Enroll Detail
          </div>
          <div>
            <v-btn @click="cancel" class="white--text" icon>
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col lg="6">
              <label>Nominated</label>
              <v-select
                v-model="formData.nominated"
                :items="[
                        { value: 1, text: 'No' },
                        { value: 2, text: 'Yes' }
                      ]"
                item-text="text"
                item-value="value"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col lg="6">
              <label>Support</label>
              <v-select
                v-model="formData.support"
                :items="[
                        { value: 1, text: 'No' },
                        { value: 2, text: 'Yes' }
                      ]"
                item-text="text"
                item-value="value"
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col lg="6">
              <label>Nominated Month</label>
              <v-select
                v-model="formData.nominated_month"
                :items="months"
                item-text="text"
                item-value="value"
                dense
                outlined
                placeholder="Select Month"
              ></v-select>
            </v-col>
            <v-col lg="6">
              <label>Nominated Year</label>
              <v-text-field
                v-model.number="formData.nominated_year"
                type="number"
                dense
                outlined
                :rules="[
                  v => (v === null || v === '' || (v >= 2020 && v <= 2030)) || 'Year must be between 2020 and 2030'
                ]"
                min="2020"
                max="2030"
              ></v-text-field>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col lg="4">
              <label>Support Month</label>
              <v-select
                v-model="formData.support_month"
                :items="months"
                item-text="text"
                item-value="value"
                dense
                outlined
                placeholder="Select Month"
              ></v-select>
            </v-col>
            <v-col lg="4">
              <label>Support Year</label>
              <v-text-field
                v-model.number="formData.support_year"
                type="number"
                dense
                outlined
                :rules="[
                    v => (v === null || v === '' || (v >= 2020 && v <= 2030)) || 'Year must be between 2020 and 2030'
                  ]"
                min="2020"
                max="2030"
              ></v-text-field>
            </v-col>
            <v-col lg="4">
              <label>Date</label>
              <date-picker
                @clearDate="formData.date = null"
                :date="formData.date"
                v-model="formData.date"
              />
            </v-col>
          </v-row>

          <v-row v-if="formData.type">
            <v-col lg="6">
              <label>Type</label>
              <v-select
                v-model="formData.type"
                :items="[
                        { value: '1', text: 'Signature' },
                        { value: '2', text: 'ATM' },
                        { value: '3', text: 'Mobile' },
                        { value: '4', text: '' }
                      ]"
                item-text="text"
                item-value="value"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col lg="6">
              <label>Month Type</label>
              <v-select
                v-model="formData.month_type"
                :items="[
                        { value: '1', text: 'Month 1' },
                        { value: '2', text: 'Month 2' },
                        { value: '3', text: 'Month 1+2' }
                      ]"
                item-text="text"
                item-value="value"
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col lg="6">
              <label>Delegated</label>
              <v-select
                v-model="formData.delagated"
                :items="[
                        { value: '1', text: 'No' },
                        { value: '2', text: 'Yes' }
                      ]"
                item-text="text"
                item-value="value"
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col lg="6">
              <label>Reimbursement</label>
              <v-select
                v-model="formData.repay"
                :items="[
                        { value: '1', text: 'No' },
                        { value: '2', text: 'Yes' }
                      ]"
                item-text="text"
                item-value="value"
                dense
                outlined
              ></v-select>
            </v-col>
          </v-row>

          <v-row>
            <v-col lg="12">
              <label>Remark</label>
              <v-textarea
               :value="formData.remark == null ? '' : formData.remark"
                v-model="formData.remark"
                dense
                outlined
                rows="3"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-row v-if="formData.signature">
            <v-col lg="12">
              <label>Signature</label>
              <v-img :src="formData.signature" max-height="200"></v-img>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-5">
          <v-spacer />
          <v-btn @click="cancel" class="mr-2">
            Cancel
          </v-btn>
          <v-btn @click="updateDetail" class="form-btn">
            <v-icon left>mdi-chevron-right-circle-outline</v-icon>Update
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DatePicker from "@/components/common/DatePicker.vue";

export default {
  components: { DatePicker },
  props: {
    dialog: {
      type: Boolean,
    },
    enrollEachData: {
      type: Object,
    },
  },
  data: () => ({
    formData: {},
  }),
  computed: {
    ...mapState("InitialData", ["months", "years"]),
  },
  watch: {
    enrollEachData: {
      handler(newVal) {
        if (newVal) {
          this.formData = JSON.parse(JSON.stringify(newVal));
          
          // Ensure month values are properly typed for v-select
          if (this.formData.nominated_month !== null && this.formData.nominated_month !== undefined) {
            this.formData.nominated_month = Number(this.formData.nominated_month);
          }
          if (this.formData.support_month !== null && this.formData.support_month !== undefined) {
            this.formData.support_month = Number(this.formData.support_month);
          }
        }
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    refresh() {
      this.$emit("refresh");
    },
    async updateDetail() {
      try {
        // Add null safety to the form data
        const updateData = {
          id: this.formData?.id,
          nominated: this.formData?.nominated ?? null,
          support: this.formData?.support ?? null,
          nominated_month: this.formData?.nominated_month ?? null,
          nominated_year: this.formData?.nominated_year ?? null,
          support_month: this.formData?.support_month ?? null,
          support_year: this.formData?.support_year ?? null,
          date: this.formData?.date ?? null,
          type: this.formData?.type ?? null,
          delagated: this.formData?.delagated ?? null,
          repay: this.formData?.repay ?? null,
          month_type: this.formData?.month_type ?? null,
          remark: this.formData?.remark,
        };

        await this.$store.dispatch("PreEnroll/updatePreEnrollList", updateData);
        this.$toast.success('Pre-Enroll detail updated successfully!');
        this.$emit("updated", updateData);
        this.cancel();
        this.refresh();
      } catch (error) {
        this.$toast.error('Failed to update pre-enroll detail.');
        console.error('Update error:', error);
      }
    },
  },
};
</script>

<style scoped></style> 